import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import HotelFilters from '../../../../components/customer/PublicCustomerScreens/HotelPages/cus-htl-Filters';
import HotelList    from '../../../../components/customer/PublicCustomerScreens/HotelPages/HotelList';
import CustomerLoginForm from '../../../../components/customer/PublicCustomerScreens/CustomerFormComponents/CustomerLoginForm';
import { useHotels } from './HotelsData';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/publicCustomerCss/EventBlogs/eventblogs.css';

function HotelsScreen() {
  const navigate = useNavigate();
  const { hotels, loading, error } = useHotels();
  const { baseUrl, authToken } = useContext(AppContext);

  const [filteredHotels, setFilteredHotels] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [wishlistIds, setWishlistIds] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    let filtered = hotels;
    if (selectedFilter !== 'all') {
      filtered = filtered.filter(
        (hotel) => hotel.starRating === parseInt(selectedFilter)
      );
    }
    if (searchTerm) {
      filtered = filtered.filter(
        (hotel) =>
          hotel.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
          hotel.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredHotels(filtered);
  }, [hotels, selectedFilter, searchTerm]);

  useEffect(() => {
    if (!authToken) return;

    const currentCustomerId = Number(localStorage.getItem('customerId'));

    axios.get(`${baseUrl}/customer/wishlist`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((res) => {
        if (res.data.success) {
          const hotelIds = res.data.data
            .filter((item) => Number(item.jjcustomer_id) === currentCustomerId)
            .filter((item) => item.jjhotelregistration_id !== null)
            .map((item) => Number(item.jjhotelregistration_id));
          setWishlistIds(hotelIds);
        }
      })
      .catch((err) => console.error('Fetch wishlist error:', err));
  }, [baseUrl, authToken]);

  const handleWishlistToggle = (hotelId, e) => {
    e && e.stopPropagation();

    if (!authToken) {
      setShowLoginModal(true);
      return;
    }

    const numericHotelId = Number(hotelId);
    const isWishlisted = wishlistIds.includes(numericHotelId);

    if (isWishlisted) {
      axios.delete(`${baseUrl}/customer/wishlist/${numericHotelId}?type=hotel`, {
        headers: { Authorization: `Bearer ${authToken}` }
      })
        .then(() => {
          setWishlistIds((prev) => prev.filter((id) => id !== numericHotelId));
        })
        .catch((err) => console.error('Remove wishlist error:', err));
    } else {
      const formData = new FormData();
      formData.append('jjhotelregistration_id', numericHotelId);

      axios.post(`${baseUrl}/customer/addWishlist`, formData, {
        headers: { Authorization: `Bearer ${authToken}` }
      })
        .then(() => {
          setWishlistIds((prev) => [...prev, numericHotelId]);
        })
        .catch((err) => console.error('Add wishlist error:', err));
    }
  };

  const handleFilterChange = (filter) => setSelectedFilter(filter);
  const handleSearch = (term) => setSearchTerm(term);
  const handleViewDetails = (hotel) => {
    navigate(`/hotels/${hotel.id}`, { state: { hotel } });
  };

  if (loading) {
    return (
      <div className="cus-htl-app-container">
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading hotels...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cus-htl-app-container">
        <div className="text-center p-5 text-danger">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cus-htl-app-container">
      <header className="eb-hero">
        <div className="eb-hero-dots" />
        <div className="eb-hero-content">
          <span className="eb-hero-eyebrow">Northern Pakistan</span>
          <h1 className="eb-hero-title">Hotels &amp; Stays</h1>
          <p className="eb-hero-sub">
            Find the perfect place to rest after a day of adventure – from
            luxury resorts to cozy guesthouses in Hunza, Skardu, Gilgit and beyond.
          </p>
          <div className="cus-htl-search-wrapper mt-4">
            <div className="cus-htl-search-container">
              <div className="input-group">
                <span className="input-group-text cus-htl-search-icon">
                  🔍
                </span>
                <input
                  type="text"
                  className="form-control cus-htl-search-input"
                  placeholder="Search by hotel name or location..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <button
                  className="btn cus-htl-search-btn"
                  onClick={() => handleSearch(searchTerm)}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="eb-hero-wave">
          <svg viewBox="0 0 1440 56" preserveAspectRatio="none">
            <path d="M0,28 C480,56 960,0 1440,28 L1440,56 L0,56 Z" fill="#f2f5f8" />
          </svg>
        </div>
      </header>
      <Container fluid className="cus-htl-main-content" style={{ marginTop: '-1rem' }}>
        <Row>
          <Col lg={3} md={4} className="cus-htl-filters-column">
            <HotelFilters
              activeFilter={selectedFilter}
              onFilterChange={handleFilterChange}
            />
          </Col>
          <Col lg={9} md={8} className="cus-htl-hotels-column">
            <HotelList
              hotels={filteredHotels}
              onViewDetails={handleViewDetails}
              wishlistIds={wishlistIds}
              onWishlist={handleWishlistToggle}
            />
          </Col>
        </Row>
      </Container>

      {showLoginModal && (
        <CustomerLoginForm onClose={() => setShowLoginModal(false)} />
      )}
    </div>
  );
}

export default HotelsScreen;